module.exports = __webpack_public_path__ + "img/local_icon.7672212f.png";